module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEbSURBVEhL7dTNSgJRGMbxMVoJFoRBCxdtuhm7gC5AvIBAiFYuxGuIaN3KO1CLcOXCC3DRSqOgcJGRYJv6P+SBw/EdP2Z05wM/jp45HzNzXo12WScv+A184h4nSJ0Gwg2cPnJIlQtYizvX8HOAW7wjHPuMuWQxRjjYeYSfO1jjpA4zNVgT5AvHcLHuXHRuRzCjp+jCmig9nKHt9YUqWJhD3OAVIzRxiSm0wM+sncxanwolg0Qpwy30hDyu8AGVeBX7SBz9FtwGp+rYdPbgNthatr6Byq/0/3GzKUIHOYAOU62+qz9RdIgdqBRVpm9wr8enUtb1bzyggNicQ3cl+nOzFlymhdgMYU1aV+yrswYnpTOaizUwjV1WSRT9AV6+vh6utUPaAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-sprout/dark/24.png
// module id = 2468
// module chunks = 2